module.exports = __webpack_public_path__ + "img/overview-header-left.e6a0879b.svg";